import { ADD_FEED_POST, BZ2_ADD_PRODUCT, HOMEPAGE_ADD_BUTTON } from 'mk/autogenerated/translations/AddMenu.ed31e6cafccfa27ef4aaf4c96636ee73'
import { bazaar_single_page_create_product_url } from 'mk/urls/functions';
import { forumPostNew } from 'mk2/apps/forum/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import MenuItem from 'mk2/components/menu/MenuItem';
import Menu from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import * as React from 'react';
import { connect } from 'react-redux';

const MENU_ID = 'add-menu';

interface OwnProps {
    className?: string;
}
interface StateProps {}
interface DispatchProps {
    onToggleMenuMore();
}

export type Props = OwnProps & StateProps & DispatchProps;

export class AddMenu extends React.Component<Props> {

    public render() {
        const { onToggleMenuMore, className } = this.props;

        return (
            <Menu
                menuId={MENU_ID}
                className={className}
                trigger={
                    <Btn
                        type={BtnType.Blue}
                        icon="fa-plus-circle"
                        label={HOMEPAGE_ADD_BUTTON}
                        onClick={onToggleMenuMore}
                    />
                }
            >
                <MenuItem
                    label={BZ2_ADD_PRODUCT}
                    icon="fa-fw fa-shopping-basket"
                    link={bazaar_single_page_create_product_url()}
                    asAnchor
                />
                <MenuItem
                    label={ADD_FEED_POST}
                    icon="fa-fw fa-comments"
                    link={forumPostNew}
                />
            </Menu>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {};
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onToggleMenuMore: () => menuToggle(MENU_ID),
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenu);
